import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { createElement, useCallback, useMemo, useState } from "react";
import { TbDotsVertical } from "react-icons/tb";

import { useClinicArrivalTasksGridActions } from "@/stores/use-clinic-arrival-tasks-grid";

import { HotelClinicResolvedPassenger } from "../../../types";
import { ClinicTaskDetailClickActionNames, clinicTaskDetailActions } from "./DetailActionsColumn";

export type DetailActionsHeaderProps = {
    taskId: string;
    allRows: HotelClinicResolvedPassenger[];
    selectedRowIds: GridRowSelectionModel;
};

function DetailActionsHeader({ taskId, allRows, selectedRowIds }: DetailActionsHeaderProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const selectedRows = useMemo(
        () => allRows.filter((row) => selectedRowIds.includes(row.listItemId)),
        [allRows, selectedRowIds]
    );
    const { updateShowTasksDetailUnassignDialog } = useClinicArrivalTasksGridActions();

    const handleUnassign = useCallback(() => {
        const listItemIds = allRows
            .filter((row) => selectedRowIds.includes(row.listItemId))
            .map((row) => row.listItemId);
        if (!listItemIds.length) return;

        updateShowTasksDetailUnassignDialog({
            taskId,
            totalPassengers: allRows.length,
            listItemIds,
        });
    }, [allRows, selectedRowIds, taskId, updateShowTasksDetailUnassignDialog]);

    const clickActions: Partial<Record<ClinicTaskDetailClickActionNames, { cb: () => void }>> = useMemo(
        () => ({
            [ClinicTaskDetailClickActionNames.PASSENGER_UNASSIGN]: {
                cb: handleUnassign,
            },
        }),
        [handleUnassign]
    );

    const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="flex items-center  justify-end  !mx-auto">
            {clinicTaskDetailActions.length > 0 && (
                <>
                    <IconButton
                        onClick={handleClickMenuOpen}
                        size="small"
                        className=" !w-[30px] grow-0 shrink-0 !h-[30px]"
                        aria-label="Satır aksiyonları menüsünü aç"
                    >
                        <TbDotsVertical size={18} />
                    </IconButton>
                    <Menu
                        sx={{
                            ":root": {},
                        }}
                        classes={{
                            paper: "!min-w-[178.58px]",
                            list: "!min-w-[178.58px]",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                    >
                        {clinicTaskDetailActions.map((action) => (
                            <MenuItem
                                disabled={!selectedRows.length}
                                key={action.label}
                                onClick={clickActions[action.onClick]?.cb}
                                sx={{}}
                            >
                                <ListItemIcon>{createElement(action.icon, { color: action.color })}</ListItemIcon>
                                <ListItemText>{action.label}</ListItemText>
                                <Typography variant="body2" sx={{ color: "text.secondary", paddingLeft: 3 }}>
                                    {selectedRows.length}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            )}
        </div>
    );
}

export default DetailActionsHeader;
